import React from "react"
import "../styles/index.scss"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Zopim from "../components/shared/zopim";
import Hero from "../components/shared/hero";
import M1 from "../components/shared/m1";
import M2 from "../components/shared/m2";
import M4 from "../components/shared/m4";
import M3 from "../components/shared/m3";
import M5 from "../components/shared/m5";
import M6 from "../components/shared/m6";
import {graphql, useStaticQuery} from "gatsby";

function IndexPage(){
    const components = {
        'hero': Hero,
        'three columns': M1,
        'grid of images': M2,
        'content and grid of images': M4,
        'three columns list': M3,
        'contact form': M5,
    };

    const data = useStaticQuery(
        graphql`
      query {
      contentfulPage {
        id
        title
        sections {
          id
          title
          subtitle
          style
          extraContent {
            extraContent
          }
          footerText
          contentText {
            ... on ContentfulBlockOfContent {
              id
              title
              ctaText
              ctaLink
              contentText {
                contentText
              }
              image {
                file {
                  url
                  contentType
                  fileName
                }
                title,
                description
              }
            }
            ... on ContentfulHero {
              id
              title
              subtitle
              ctaLink
              ctaText
              contentText {
                contentText
              }
              image {
                file {
                  url
                  contentType
                }
                title,
                description
              }        
            }
            ... on ContentfulList {
              id
              title
              items {
                id
                title
                list {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
    `);

    const sections = [];

    data.contentfulPage.sections.forEach((sectionData) => {
        let CurrentComponent = components[sectionData.style];
        sections.push(<CurrentComponent key={sectionData.id} data={sectionData} />);
    });

    return (
        <Layout>
            <Zopim />
            <SEO title="Home" />
            <main role="main">
                {sections}
            </main>
            <footer>
                <M6/>
            </footer>
        </Layout>
    )
}

export default IndexPage
